import { render, staticRenderFns } from "./LikedProductCard.vue?vue&type=template&id=58eec6bc&scoped=true&"
import script from "./LikedProductCard.vue?vue&type=script&lang=js&"
export * from "./LikedProductCard.vue?vue&type=script&lang=js&"
import style0 from "./LikedProductCard.vue?vue&type=style&index=0&id=58eec6bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eec6bc",
  null
  
)

export default component.exports